export function NoData() {
  return <div className="font-semibold text-neutrals-900">--</div>;
}
